// config/errorCodeMap.ts
//
// This file does NOT contain any user-facing text. It only maps API error
// codes to i18n translation KEYS. The keys are derived from the English
// text itself (e.g. "Need Help" -> "need_help") so they stay readable in
// this file. The actual display text lives in your locale files, e.g.
// locales/en/errors.json.
//
// Not every code has both a title and a description mapped - some only have
// a title, some only have a description. errorHelper.ts handles that.
// Multiple codes that share the exact same text automatically share the
// same i18n key (e.g. several "No Pending Authorizations" codes).

// Maps an API error code -> the i18n key for its TITLE (short heading).
export const ERROR_TITLE_KEY_MAP: Record<string, string> = {
  "601": "user_not_found",
  "602": "password_mismatch",
  "603": "otp_mismatch",
  "604": "expired",
  "605": "answer_not_found",
  "606": "answer_mismatch",
  "607": "security_key_mismatch",
  "608": "invalid_old_password",
  "609": "password_cannot_be_empty",
  "610": "unknown_question",
  "611": "invalid_request",
  "612": "invalid_user_type",
  "613": "invalid_or_expired_refresh_token",
  "614": "failed_to_extract_claims",
  "615": "user_code_not_found_in_refresh_token",
  "616": "user_not_found_for_refresh_token",
  "617": "email_cannot_be_null_or_empty",
  "618": "email_or_otp_cannot_be_null_or_empty",
  "619": "error_while_saving_fee_feature",
  "620": "error_while_updating_fee_feature",
  "621": "failed_to_fetch_all_security_questions",
  "622": "security_question_not_found_with_id",
  "623": "failed_to_fetch_security_question",
  "624": "failed_to_create_security_question",
  "625": "failed_to_update_security_question",
  "626": "failed_to_delete_security_question",
  "627": "otp_not_found",
  "628": "otp_expired_or_invalid",
  "629": "permission_not_found",
  "630": "assembler_error",
  "631": "permission_ids_by_user_code",
  "632": "user_data_null_or_empty",
  "633": "user_login_id_or_email_empty",
  "634": "password_or_mpin_empty",
  "635": "otp_empty",
  "636": "mpin_empty",
  "637": "password_empty",
  "638": "only_corporate_emails_allowed",
  "639": "mpin_must_be_6_digits",
  "640": "invalid_email_format",
  "641": "otp_must_be_6_digits",
  "642": "new_mpin_must_be_different",
  "643": "failed_to_get_payment_type_for_user",
  "644": "required_field_missing",
  "645": "invalid_sub_feature",
  "646": "html_not_allowed",
  "647": "error_while_saving_payment_type",
  "648": "error_while_updating_payment_type",
  "649": "failed_to_get_all_payment_types",
  "650": "failed_to_get_payment_type_by_id",
  "651": "error_while_saving_authorization_matrix",
  "652": "error_while_updating_authorization_matrix",
  "653": "error_while_deleting_authorization_matrix",
  "654": "error_while_getting_authorization_matrix_by_id",
  "655": "failed_to_get_payment_type_id",
  "656": "failed_to_get_sub_feature_by_payment_type_id",
  "657": "failed_to_get_sub_feature_for_user",
  "658": "failed_to_get_payment_type_for_user_2",
  "659": "authorization_matrix_not_found",
  "660": "generate_sql_pk_error",
  "661": "consent_not_enabled",
  "676": "email_already_registered",
  "677": "email_already_registered",
  "680": "consent_not_have_permission",
  "681": "revoked_consent",
  "693": "admin_not_approved",
  "694": "user_have_multiple_consent",
  "727": "invalid_email_id",
  "728": "enter_email",
  "754": "email_already_exist",
  "762": "mobileno_already_registered",
  "770": "company_already_exists",
  "801": "company_data_missing",
  "802": "company_bank_data_missing",
  "803": "feature_data_missing",
  "804": "bank_data_missing",
  "805": "bank_feature_data_missing",
  "806": "feature_account_creation_failed",
  "807": "invalid_file_format",
  "808": "file_path_not_configured",
  "809": "feature_account_update_failed",
  "810": "company_feature_fee_missing",
  "811": "company_feature_fee_subscription_error",
  "812": "company_feature_fee_update_error",
  "813": "company_account_missing",
  "814": "sme_company_id_error",
  "815": "company_id_error",
  "816": "company_bank_id_error",
  "817": "company_account_name_error",
  "818": "company_account_number_error",
  "819": "company_account_type_error",
  "820": "company_account_currency_code_error",
  "821": "company_account_bank_name_error",
  "822": "company_account_status_error",
  "823": "company_account_id_error",
  "824": "sme_bank_onboarding_error",
  "825": "sme_bank_fetch_error",
  "826": "auth_group_already_mapped",
  "827": "sme_bank_get_all_onboarded_error",
  "828": "sme_bank_get_all_accounts_error",
  "829": "sme_bank_suspend_delete_account_error",
  "830": "bank_fetch_failed",
  "831": "integration_account_details_fetch_failed",
  "832": "company_account_creation_failed",
  "833": "company_account_fetch_error",
  "834": "company_account_update_failed",
  "835": "company_account_find_by_id_error",
  "836": "company_account_find_by_number_error",
  "837": "company_account_find_by_sme_company_id_error",
  "838": "company_account_find_by_user_code_error",
  "839": "account_details_fetch_by_number_failed",
  "840": "company_comp_account_creation_failed",
  "841": "company_comp_account_fetch_error",
  "842": "company_comp_account_update_failed",
  "843": "company_comp_account_find_by_id_error",
  "844": "company_comp_account_find_by_sme_company_id_error",
  "845": "company_comp_account_find_by_user_code_error",
  "846": "company_comp_account_details_fetch_failed",
  "847": "company_feature_account_creation_failed",
  "848": "company_feature_account_fetch_error",
  "849": "company_feature_account_update_failed",
  "850": "company_feature_account_find_by_id_error",
  "851": "company_feature_account_find_by_user_feature_id_error",
  "852": "company_feature_account_find_by_user_id_error",
  "853": "company_feature_account_details_fetch_failed",
  "854": "company_feature_fee_creation_failed",
  "855": "company_feature_fee_fetch_failed",
  "856": "company_feature_fee_find_by_id_error",
  "857": "company_feature_fee_find_by_sme_company_id_error",
  "858": "company_role_permission_creation_failed",
  "859": "company_role_permission_fetch_failed",
  "860": "company_role_permission_update_failed",
  "861": "company_role_permission_find_by_id_error",
  "862": "company_role_permission_find_by_comp_role_id_error",
  "863": "company_role_creation_failed",
  "864": "company_role_fetch_failed",
  "865": "company_role_find_by_id_error",
  "866": "company_role_update_failed",
  "867": "company_user_feature_creation_failed",
  "868": "company_user_feature_fetch_failed",
  "869": "company_user_feature_update_failed",
  "870": "company_user_feature_find_by_id_error",
  "871": "company_user_feature_find_by_sme_company_id_error",
  "872": "company_user_feature_get_features_failed",
  "873": "company_user_role_creation_failed",
  "874": "company_user_role_fetch_failed",
  "875": "company_user_role_get_by_sme_company_id_error",
  "876": "company_user_role_find_by_id_error",
  "877": "company_user_role_update_failed",
  "878": "sme_onboarding_error",
  "879": "sme_get_all_companies_failed",
  "880": "sme_find_company_by_id_error",
  "881": "sme_add_company_role_failed",
  "882": "sme_company_role_permission_error",
  "883": "sme_add_role_failed",
  "884": "sme_role_permission_error",
  "885": "sme_get_all_banks_failed",
  "886": "sme_find_bank_by_id_error",
  "887": "system_bank_get_all_error",
  "888": "system_bank_find_by_id_error",
  "889": "system_bank_search_error",
  "890": "mas_user_get_all_error",
  "891": "mas_user_get_all_customers_failed",
  "892": "mas_user_get_all_by_type_failed",
  "893": "mas_user_not_found",
  "894": "mas_user_find_by_id_error",
  "895": "mas_user_admin_creation_failed",
  "896": "mas_user_onboard_invitation_failed",
  "897": "mas_user_onboard_verification_failed",
  "898": "mas_user_email_otp_missing",
  "899": "mas_user_otp_not_found",
  "900": "timeout_error",
  "910": "technical_error",
  "911": "mas_user_role_creation_failed",
  "912": "mas_user_role_get_all_error",
  "913": "mas_user_role_find_by_id_error",
  "914": "mas_user_role_update_failed",
  "915": "mas_role_get_all_error",
  "916": "mas_role_find_by_id_error",
  "917": "mas_role_permission_creation_failed",
  "918": "mas_role_permission_get_all_error",
  "919": "mas_role_permission_find_by_id_error",
  "920": "mas_role_permission_update_failed",
  "921": "mas_fee_get_all_failed",
  "922": "fee_get_all_error",
  "923": "fee_find_by_id_error",
  "924": "fee_creation_failed",
  "925": "fee_update_failed",
  "926": "fee_delete_failed",
  "927": "fee_feature_fetch_all_error",
  "928": "fee_feature_find_by_id_error",
  "929": "fee_feature_delete_error",
  "930": "fee_feature_update_error",
  "931": "fee_feature_creation_error",
  "932": "dashboard_data_not_found",
  "933": "dashboard_data_fetch_error",
  "934": "company_user_onboard_invitation_failed",
  "935": "role_name_required",
  "936": "invalid_company_role_id",
  "937": "menu_name_required",
  "938": "invalid_menu_id",
  "939": "permission_name_required",
  "940": "mas_user_otp_mismatch",
  "941": "mas_user_invalid_request",
  "942": "mas_user_onboard_approval_failed",
  "943": "mas_user_mpin_set_failed",
  "944": "mas_user_update_not_found",
  "945": "mas_user_update_failed",
  "946": "mas_user_conversion_not_found",
  "947": "mas_user_conversion_failed",
  "948": "mas_user_find_by_role_id_error",
  "949": "mas_user_find_company_users_by_role_id_error",
  "951": "mas_user_company_users_fetch_failed",
  "952": "company_users_fetch_failed",
  "953": "pending_transactions_in_auth_range",
  "954": "money_conversion_failed",
  "959": "company_user_suspend_reactivate_error",
  "960": "invalid_status_provided",
  "961": "company_info_update_error",
  "962": "invalid_company_id",
  "963": "mas_fee_search_error",
  "964": "fee_not_found",
  "978": "invalid_onboarding_type",
  "1001": "purpose_codes_not_found",
  "1002": "beneficiaries_not_found",
  "1003": "invalid_beneficiary_id",
  "1004": "payment_types_fetch_error",
  "1005": "lookup_data_not_found",
  "1006": "authorization_matrix_not_found",
  "1007": "workflow_not_found",
  "1008": "workflow_update_failed",
  "1009": "unsupported_action_type",
  "1010": "invalid_payment_indicator",
  "1011": "payment_transaction_not_found",
  "1012": "duplicate_corebank_push",
  "1013": "error_converting_to_dto",
  "1014": "mapping_failed",
  "1015": "object_is_null",
  "1016": "transfer_type_is_null",
  "1017": "transfer_type_invalid",
  "1018": "beneficiary_account_is_null",
  "1019": "debit_amount_invalid",
  "1020": "currency_code_is_null",
  "1021": "country_code_is_null",
  "1022": "payment_date_is_null",
  "1023": "transaction_status_is_null",
  "1024": "credit_amount_is_null",
  "1025": "payment_details_is_null",
  "1026": "internal_remarks_is_null",
  "1027": "schedule_time_is_null",
  "1028": "recurring_id_is_null",
  "1029": "purpose_code_is_null",
  "1030": "payment_reference_is_null",
  "1031": "charge_amount_invalid",
  "1032": "charge_bearer_type_is_null",
  "1033": "beneficiary_email_is_null",
  "1034": "beneficiary_email_invalid",
  "1035": "mobile_no_is_null",
  "1036": "mobile_no_invalid",
  "1037": "transfer_note_is_null",
  "1038": "recurring_details_invalid",
  "1039": "page_no_is_null",
  "1040": "page_sort_by_is_null",
  "1041": "product_and_account_not_entitled",
  "1042": "holiday_cutoff_exceeded",
  "1043": "currency_cutoff_exceeded",
  "1044": "account_retrieval_error",
  "1045": "accounts_not_found",
  "1046": "query_failed",
  "1047": "account_balance_retrieval_error",
  "1048": "invalid_amount",
  "1049": "amount_exceeds_limit",
  "1050": "limit_check_failed",
  "1052": "approval_limit_exceeded",
  "1053": "daily_limit_not_found",
  "1054": "approval_limit_not_found",
  "1055": "no_data_found",
  "1056": "procedure_exception",
  "1057": "unknown_error",
  "1058": "error_authorization_insert",
  "1059": "generic_error",
  "1060": "approver_count_not_found",
  "1061": "bank_routing_error",
  "1062": "banks_not_found",
  "1063": "invalid_fx_quote_request",
  "1064": "fx_quote_creation_error",
  "1065": "fx_quote_accept_error",
  "1077": "payment_already_initiated",
  "1100": "system_error",
  "1201": "user_not_authenticated_or_authorized",
  "1202": "user_profile_or_role_missing",
  "1203": "payment_type_not_found",
  "1204": "authorization_matrix_not_found",
  "1205": "beneficiary_not_found",
  "1206": "error_fetching_beneficiaries",
  "1207": "invalid_beneficiary_id",
  "1208": "already_removed",
  "1209": "not_found_with_user_id",
  "1210": "mapping_failed_for_auth_history",
  "1211": "error_while_retrieving",
  "1212": "user_permission_missing",
  "1213": "status_already_present_for_beneficiary",
  "1214": "beneficiary_is_inactive",
  "1215": "unknown_status_for_beneficiary",
  "1216": "status_already_reject_for_beneficiary",
  "1217": "ifsc_or_swift_code_unsupported_country_code",
  "1218": "object_is_null",
  "1219": "beneficiary_name_is_null",
  "1220": "beneficiary_email_is_null",
  "1221": "ifsc_or_swift_code_is_null",
  "1222": "beneficiary_nick_name_is_null",
  "1223": "beneficiary_bank_name_is_null",
  "1224": "beneficiary_bank_clearing_code_is_null",
  "1225": "page_no_is_null",
  "1226": "page_size_is_null",
  "1227": "page_sort_by_is_null",
  "1228": "beneficiary_id_is_null",
  "1229": "field_contains_special_characters",
  "1230": "beneficiary_email_invalid",
  "1231": "beneficiary_already_present",
  "1232": "iban_no_is_empty",
  "1233": "iban_no_is_too_short",
  "1234": "sme_compid_and_request_given_compid_mismatch",
  "1235": "assembler_failed",
  "1236": "feature_not_allowed_for_this_user",
  "1237": "remarks_missing_add_remark",
  "1238": "beneficiary_account_is_null",
  "1239": "beneficiary_already_waiting_for_approval",
  "1240": "edit_not_allowed_pending_transactions",
  "1241": "success",
  "1242": "query_failed",
  "1243": "beneficiary_reject_remark_mandatory",
  "1244": "status_code_is_null",
  "1245": "favorites_cannot_be_assigned",
  "1246": "invalid_request_sub_feature_id_required",
  "1247": "beneficiary_update_failed",
  "1248": "sme_not_authenticated",
  "1249": "update_successful",
  "1250": "partial_update_successful",
  "1251": "update_failed",
  "1252": "iban_number_invalid",
  "1253": "invalid_beneficiary",
  "1254": "validation_failed",
  "1255": "beneficiary_edit_not_allowed",
  "1256": "it_s_not_approved_beneficiary",
  "1257": "beneficiary_nick_name_is_invalid",
  "1258": "beneficiary_nick_name_already_exists",
  "1259": "user_not_allowed_to_approve",
  "1260": "user_role_is_not_assigned",
  "1261": "not_gx_user",
  "1262": "consent_usage_subtype_is_empty",
  "1263": "entered_amount_is_higher_than_balance",
  "1264": "invalid_amount_or_balance",
  "1265": "invalid_amount_precision",
  "1266": "create_fxquote_error",
  "1267": "nonce_creation_failed",
  "1268": "nonce_id_is_null",
  "1269": "invalid_nonce",
  "1271": "name_missing",
  "1272": "creation_failed",
  "1401": "error_retrieving_dashboard_balances",
  "1402": "error_fetching_total_account_balance",
  "1403": "error_fetching_total_assets_balance",
  "1404": "account_details_not_found_for_id",
  "1405": "currencies_not_found",
  "1406": "error_fetching_liabilities_total_balance",
  "1407": "invalid_account_id",
  "1408": "statements_not_found",
  "1409": "failed_to_save_custom_statement_request",
  "1410": "immediate_attention_transactions_not_found",
  "1411": "recent_transactions_not_found",
  "1412": "mapping_failed_for_transaction_history",
  "1413": "account_activities_not_found",
  "1414": "lookup_type_not_found",
  "1415": "entity_to_dto_convertion_failed",
  "1416": "no_lookup_data_found",
  "1417": "invalid_user_id",
  "1418": "request_dto_null",
  "1419": "account_id_invalid",
  "1420": "account_no_invalid",
  "1421": "deposit_account_activities_not_found",
  "1422": "loan_account_activities_not_found",
  "1423": "user_not_authenticated_or_authorized",
  "1424": "account_iban_no_invalid",
  "1425": "accounts_products_not_found_for_user",
  "1426": "statement_not_download",
  "1427": "cards_not_found",
  "1428": "transaction_id_invalid",
  "1429": "account_no_too_short",
  "1430": "date_is_empty",
  "1431": "start_date_invalid",
  "1432": "delivery_type_is_empty",
  "1433": "delivery_type_must_mail_or_whatsapp",
  "1434": "delivery_type_must_courier_or_collection",
  "1435": "only_one_chequebook_allowed",
  "1436": "invalid_chequebook_leaves",
  "1437": "courier_collector_name_required",
  "1438": "courier_country_code_missing",
  "1439": "courier_collector_number_required",
  "1440": "courier_collector_address_required",
  "1441": "courier_collector_state_required",
  "1442": "courier_collector_city_required",
  "1443": "courier_collector_zip_required",
  "1444": "invalid_bank_branch_id",
  "1445": "bank_branch_name_required",
  "1446": "bank_branch_address_required",
  "1447": "bank_branch_coordinates_required",
  "1448": "collection_center_country_code_required",
  "1449": "collection_center_phone_num_required",
  "1450": "delivery_type_required",
  "1451": "self_physical_copy_required",
  "1452": "self_email_required",
  "1453": "auditor_fields_must_be_empty_for_self",
  "1454": "auditor_physical_copy_required",
  "1455": "both_physical_copies_required",
  "1456": "self_email_required_for_both",
  "1457": "unsupported_delivery_type",
  "1458": "auditor_name_required",
  "1459": "auditor_email_required",
  "1460": "auditor_physical_copy_missing_fields",
  "1461": "auditor_fields_must_be_empty_when_no_physical_copy",
  "1462": "chequebook_type_must_standard",
  "1463": "auditor_country_code_required",
  "1464": "auditor_phone_required",
  "1465": "auditor_address_required",
  "1466": "auditor_state_required",
  "1467": "auditor_city_required",
  "1468": "auditor_zip_code_required",
  "1469": "total_balance_not_found",
  "1470": "total_balance_currency_not_found",
  "1471": "total_assets_balance_not_found",
  "1472": "total_assets_currency_not_found",
  "1473": "total_liabilities_balance_not_found",
  "1474": "total_liabilities_currency_not_found",
  "1475": "convert_currency_not_found",
  "1476": "central_bank_response_not_found",
  "1477": "unknown_status_for_account",
  "1478": "no_pending_request",
  "1479": "progress_status_not_update",
  "1480": "completed_status_not_update",
  "1481": "reset_pending_not_update",
  "1482": "bank_list_not_found",
  "1483": "favourite_accounts_not_found",
  "1484": "favourite_deposit_not_found",
  "1485": "favourite_loan_account_not_found",
  "1486": "favourite_card_not_found",
  "1487": "email_template_not_found",
  "1488": "unknown_error",
  "1491": "portal_transactions_not_found",
  "1498": "card_activity_not_found",
  "1600": "invalid_payer",
  "1601": "payer_not_found",
  "1602": "authorization_failed",
  "1603": "processing_error",
  "1604": "query_failed",
  "1605": "missing_payer_data",
  "1606": "missing_payer_name",
  "1607": "missing_email",
  "1608": "missing_address",
  "1609": "missing_bank_name",
  "1610": "remarks_required",
  "1611": "payer_removed",
  "1612": "unknown_status",
  "1613": "invalid_sme",
  "1614": "access_not_allowed",
  "1615": "pending_approval",
  "1616": "already_rejected",
  "1617": "status_exists",
  "1618": "authorization_data_missing",
  "1619": "already_approved",
  "1620": "invalid_approval_status",
  "1621": "update_successful",
  "1622": "update_failed",
  "1623": "partial_update_failed",
  "1624": "invoice_exists",
  "1625": "purchase_order_exists",
  "1626": "invalid_email",
  "1627": "not_approved",
  "1628": "missing_mobile_number",
  "1629": "missing_country_code",
  "1630": "missing_mobile_code",
  "1631": "email_already_exists",
  "1632": "mobile_already_exists",
  "1634": "id_verification_failed",
  "1635": "image_missing",
  "1636": "id_image_missing",
  "1637": "selfie_missing",
  "1638": "technical_error",
  "1639": "timeout_error",
  "1640": "service_error",
  "1700": "invalid_rtp_request",
  "1701": "internal_error",
  "1702": "invalid_status_update",
  "1703": "save_failed",
  "1704": "invalid_rtp_request_filter",
  "1705": "invalid_payer",
  "1706": "invalid_deposit_account",
  "1707": "invalid_amount",
  "1708": "invalid_collection_date",
  "1709": "invalid_expiry_date",
  "1710": "sme_not_authenticated",
  "1711": "invalid_payer_contact",
  "1712": "invalid_mobile_number",
  "1713": "invalid_email",
  "1714": "invalid_payer_name",
  "1715": "invalid_request",
  "1716": "invalid_page_number",
  "1717": "invalid_page_size",
  "1718": "invalid_search_text",
  "1719": "payer_list_empty",
  "1720": "rtp_list_empty",
  "1722": "user_id_not_found",
  "1723": "accounts_not_found",
  "1724": "rtp_fetch_failed",
  "1725": "payer_contact_required",
  "1726": "payer_name_required",
  "1727": "record_not_found",
  "1728": "query_failed",
  "1729": "data_not_found_for_user_id",
  "1730": "invalid_webhook_token",
  "1731": "webhook_token_missing",
  "1732": "invalid_rtp_status_code",
  "1733": "invalid_rtp_details",
  "1812": "missing_login_process_id",
  "1820": "device_deregistered",
  "1898": "device_already_registered_with_other_user",
  "2003": "file_format_required",
  "2004": "invalid_debit_account",
  "2005": "value_date_required",
  "2006": "job_not_found",
  "2007": "empty_file",
  "2008": "invalid_file_name",
  "2009": "invalid_file_type",
  "2010": "file_path_not_configured_2",
  "2011": "file_processing_failed",
  "2012": "account_not_found",
  "2013": "invalid_job_process_id",
  "2014": "reject_notes_required",
  "2015": "invalid_reject_status",
  "2016": "invalid_job_name",
  "2017": "invalid_bulk_type_status",
  "2018": "invalid_unique_key",
  "2019": "already_processed",
  "2020": "already_rejected",
  "2021": "invalid_lookup_type",
  "2022": "invalid_action",
  "2023": "invalid_reject_action",
  "2024": "authorization_type_required",
  "2025": "approval_status_required",
  "2026": "remark_required",
  "2027": "bulk_type_missing",
  "2028": "invalid_job_id_for_selected_bulk_type",
  "2029": "file_required",
  "2030": "invalid_action",
  "2031": "reject_notes_length_exceeded",
  "2032": "invalid_value_date",
  "2033": "query_execution_failed",
  "2034": "file_name_exists",
  "2035": "bulk_type_required",
  "2036": "file_already_exists",
  "2037": "file_path_not_found",
  "2038": "failed_to_move_file",
  "2039": "file_path_missing",
  "2040": "self_update_not_allowed",
  "2041": "payment_type_or_currency_missing",
  "2042": "invalid_status",
  "2043": "file_read_failed",
  "2044": "invalid_file_data",
  "2045": "formula_not_allowed",
  "2131": "direct_debits_not_found",
  "2132": "direct_debits_not_found_for_status",
  "2133": "date_not_found",
  "2205": "passed_consent_are_allowed_to_revoke",
  "2206": "single_instant_payment_consent_action_error",
  "2207": "single_future_dated_payment_consent_action_error",
  "2208": "account_already_exist",
  "5003": "cache_operation_failed",
  AccountsNotFound: "no_accounts_available",
  AuthMatrixNotFound: "authmatrix_transaction_type_not_found",
  BanksNotFound: "no_banks_available",
  CountryListEmpty: "country_list_empty",
  EnterMPinIsAlreadyRegister: "enter_mpin_is_already_register",
  ExistingMPinIsNotSame: "existing_mpin_is_not_same",
  IncorrectMPin: "incorrect_mpin",
  InviteUserNotFound: "invite_user_not_found",
  "MPIN Previously Used": "mpin_previously_used",
  MPINMustBeExactly: "mpin_must_be_exactly_6_digits",
  ManageThirdPartyNotFound: "no_third_party_found",
  ManageUserNotFound: "manage_user_not_found",
  NewMPINCannotBeSameAsOldMPIN: "new_mpin_cannot_be_same_as_old_mpin",
  NoPendingApprovals: "no_pending_authorizations",
  Nofileselected: "file_selection_error",
  "PleaseEnter6DigitMPIN.": "please_enter_a_6_digit_mpin",
  PleaseMakeSureYourMPINMatch: "please_make_sure_your_mpin_match",
  UserAccessReqNotFound: "user_access_request_not_found",
  bioMetricAuthToManyTimes: "biometric_authentication_to_many_times",
  consentFailed: "consent_failed",
  consentUpdateFailed: "consent_update_failed",
  healthCheckError: "health_check_error",
  largeFileSelectError: "invalid_file_selection",
  noAccountsFound: "no_accounts_found",
  noAdminUsers: "no_admin_users_found",
  noApprovalFound: "no_approval_found",
  noBankFound: "no_bank_found",
  noBeneficiaryFound: "no_beneficiary_found",
  noCardsFound: "no_cards_found",
  noCbsScheduleTransactions: "no_cbs_schedule_transactions",
  noCbsScheduleTransfer: "no_cbs_schedule_transfer",
  noConsentDetails: "consent_details_not_available",
  noConsentServiceDetails: "consent_service_details_not_available",
  noConsentServiceUpdates: "no_consent_service_updates",
  noConsentUpdates: "no_consent_updates",
  noCurrentConsentServices: "no_current_consent_services",
  noCurrentConsents: "no_current_consents",
  noDepositsFound: "no_deposits_found",
  noHistoryConsentServices: "no_consent_service_history",
  noHistoryConsents: "no_consent_history",
  noInstantPayBeneficiaryFound: "no_instant_pay_beneficiary_found",
  noLoansFound: "no_loans_found",
  noPaymentHistory: "no_payment_history",
  noPaymentTypeFound: "no_payment_type_found",
  noPortalScheduleTransfer: "no_portal_schedule_transfer",
  noQuickTransferFound: "no_quick_transfer_found",
  noRecentTransactionFound: "no_recent_transaction_found",
  noRepairTransactionFound: "no_repair_transaction_found",
  noRtpFound: "no_rtp_found",
  noScheduleTransactionFound: "no_schedule_transaction_found",
  noScheduleTransferFound: "no_schedule_transfer_found",
  noTransactionFound: "no_transaction_found",
  nopayerFound: "no_payer_found",
  pendingApprovalLeftBeneficiary: "no_pending_authorizations",
  pendingApprovalLeftBulkPayment: "no_pending_authorizations",
  pendingApprovalLeftPayer: "no_pending_authorizations",
  pendingApprovalLeftPayroll: "no_pending_authorizations",
  pendingApprovalLeftTransaction: "no_pending_authorizations",
  pleaseEnterMPIN: "please_enter_mpin",
  pleaseSelectFile: "file_requirement",
  redirectionTimeOut: "redirection_timeout",
  selectedFileExceed: "upload_limitation",
};

// Maps an API error code -> the i18n key for its DESCRIPTION (longer detail text).
export const ERROR_DESCRIPTION_KEY_MAP: Record<string, string> = {
  "601":
    "we_couldn_t_find_an_account_with_the_provided_details_please_check_and_try_again",
  "602": "the_password_entered_does_not_match_our_records_please_try_again",
  "603": "the_otp_entered_is_incorrect_please_check_and_try_again",
  "604": "the_session_or_otp_has_expired_please_request_a_new_one",
  "605":
    "the_provided_answer_could_not_be_found_please_re_enter_or_reset_your_credentials",
  "606": "the_provided_answer_does_not_match_our_records",
  "607": "the_provided_security_key_does_not_match_our_records",
  "608": "the_old_password_you_entered_is_invalid_please_try_again",
  "609": "password_cannot_be_empty_please_enter_a_valid_password",
  "610": "unknown_security_question_please_try_again_with_valid_details",
  "611": "the_request_made_was_invalid_please_try_again",
  "612": "invalid_user_type_detected_please_contact_support",
  "613": "your_session_has_expired_please_log_in_again",
  "614": "we_were_unable_to_process_your_session_please_log_in_again",
  "615": "user_details_missing_in_session_please_log_in_again",
  "616": "no_user_found_for_this_session_please_log_in_again",
  "617": "email_cannot_be_null_or_empty_please_enter_a_valid_email",
  "618": "email_or_otp_cannot_be_empty_please_fill_in_the_required_fields",
  "619": "an_error_occurred_while_saving_the_fee_feature",
  "620": "an_error_occurred_while_updating_the_fee_feature",
  "621": "failed_to_retrieve_security_questions_please_try_again_later",
  "622": "security_question_not_found_with_the_given_id",
  "623": "failed_to_fetch_the_requested_security_question",
  "624": "unable_to_create_a_new_security_question_please_try_again_later",
  "625": "unable_to_update_the_security_question_please_try_again_later",
  "626": "unable_to_delete_the_security_question_please_try_again_later",
  "627": "no_otp_found_for_this_request_please_request_a_new_one",
  "628": "otp_has_expired_or_is_invalid_please_request_a_new_one",
  "629": "required_permission_not_found_please_contact_your_administrator",
  "630": "an_internal_error_occurred_while_processing_your_request",
  "631": "unable_to_retrieve_permissions_for_the_user_please_try_again_later",
  "632": "user_data_cannot_be_null_or_empty_please_provide_valid_details",
  "633": "user_login_id_or_email_cannot_be_empty_please_provide_valid_details",
  "634": "password_or_mpin_cannot_be_empty_please_enter_a_valid_value",
  "635": "otp_cannot_be_empty_please_provide_the_code_sent_to_you",
  "636": "mpin_cannot_be_empty_please_enter_your_mpin",
  "637": "password_cannot_be_empty_please_enter_your_password",
  "638": "only_corporate_emails_are_allowed_please_use_your_company_email",
  "639": "mpin_must_be_exactly_6_digits_long",
  "640": "invalid_email_format_please_check_and_try_again",
  "641": "otp_must_be_exactly_6_digits_long",
  "642": "new_mpin_must_be_different_from_the_old_mpin",
  "643": "unable_to_retrieve_payment_type_details_for_the_user",
  "644": "a_required_field_is_missing_please_complete_all_mandatory_fields",
  "645": "invalid_sub_feature_specified",
  "646": "html_input_is_not_allowed",
  "647": "an_error_occurred_while_saving_the_payment_type_please_try_again",
  "648": "an_error_occurred_while_updating_the_payment_type_please_try_again",
  "649":
    "we_couldn_t_retrieve_the_list_of_payment_types_please_try_again_later",
  "650":
    "we_couldn_t_fetch_the_payment_type_details_for_the_given_id_please_try_again",
  "651":
    "an_error_occurred_while_saving_the_authorization_matrix_please_try_again",
  "652":
    "an_error_occurred_while_updating_the_authorization_matrix_please_try_again",
  "653":
    "an_error_occurred_while_deleting_the_authorization_matrix_please_try_again",
  "654": "unable_to_retrieve_the_authorization_matrix_details_for_the_given_id",
  "655": "we_couldn_t_retrieve_the_payment_type_id_please_check_and_try_again",
  "656": "unable_to_retrieve_sub_features_for_the_given_payment_type_id",
  "657": "unable_to_retrieve_sub_features_for_this_user",
  "658": "unable_to_retrieve_payment_type_details_for_this_user",
  "659": "authorization_matrix_not_found_please_contact_your_administrator",
  "660":
    "an_error_occurred_while_generating_database_keys_please_try_again_later",
  "661":
    "the_requested_operation_cannot_proceed_because_consent_has_not_been_enabled",
  "676": "this_email_address_is_already_associated_with_an_existing_user",
  "677": "this_email_address_is_already_associated_with_an_existing_user",
  "680":
    "the_user_does_not_have_the_required_consent_permission_to_perform_this_action",
  "681":
    "the_requested_operation_cannot_proceed_because_the_consent_has_been_revoked_by_the_user",
  "694":
    "the_user_has_multiple_active_consents_unable_to_transfer_the_delegated_users",
  "762":
    "this_mobile_number_address_is_already_associated_with_an_existing_user",
  "770": "this_company_name_already_exists_please_choose_another_name",
  "801": "company_data_is_null_or_empty_please_provide_valid_company_details",
  "802": "company_bank_data_is_null_or_empty_please_provide_valid_bank_details",
  "803": "feature_data_is_missing_or_invalid",
  "804": "bank_data_is_missing_or_invalid",
  "805": "bank_feature_data_is_missing_or_invalid",
  "806": "failed_to_create_feature_account_because_data_is_missing",
  "807": "the_uploaded_file_format_is_invalid",
  "808": "upload_the_file_and_then_download",
  "809": "failed_to_update_feature_account_due_to_invalid_input",
  "810": "company_feature_fee_details_are_missing",
  "811": "error_occurred_while_subscribing_company_feature_fee",
  "812": "error_occurred_while_updating_company_feature_fee",
  "813": "company_account_information_is_missing",
  "814": "invalid_sme_company_id_provided_for_account",
  "815": "invalid_company_id_provided_for_account",
  "816": "invalid_company_bank_id_provided",
  "817": "invalid_company_account_name_provided",
  "818": "invalid_or_missing_company_account_number",
  "819": "invalid_or_missing_company_account_type",
  "820": "invalid_or_missing_company_account_currency_code",
  "821": "invalid_or_missing_company_account_bank_name",
  "822": "invalid_or_missing_company_account_status",
  "823": "invalid_company_account_id_provided",
  "824": "error_occurred_during_sme_bank_onboarding",
  "825": "error_occurred_while_fetching_sme_bank_records",
  "826": "error_occurred_while_finding_sme_bank_by_id",
  "827": "failed_to_fetch_all_onboarded_sme_banks",
  "828": "failed_to_fetch_all_sme_bank_accounts_by_bank",
  "829": "error_occurred_while_suspending_or_deleting_sme_bank_account",
  "830": "failed_to_fetch_bank_details",
  "831": "failed_to_fetch_account_details_from_external_integration",
  "832": "failed_to_create_company_account_due_to_invalid_input",
  "833": "error_occurred_while_fetching_company_account_records",
  "834": "error_occurred_while_updating_company_account",
  "835": "error_occurred_while_finding_company_account_by_id",
  "836": "error_occurred_while_finding_company_account_by_account_number",
  "837": "error_occurred_while_finding_company_account_by_sme_company_id",
  "838": "error_occurred_while_finding_company_account_by_user_code",
  "839": "failed_to_fetch_account_details_using_account_number",
  "840": "failed_to_create_company_comp_account",
  "841": "error_occurred_while_fetching_company_comp_accounts",
  "842": "error_occurred_while_updating_company_comp_account",
  "843": "error_occurred_while_finding_company_comp_account_by_id",
  "844": "error_occurred_while_finding_company_comp_account_by_sme_company_id",
  "845": "error_occurred_while_finding_company_comp_accounts_by_user_code",
  "846": "failed_to_fetch_company_comp_account_details_using_account_number",
  "847": "failed_to_create_company_feature_account",
  "848": "error_occurred_while_fetching_company_feature_accounts",
  "849": "error_occurred_while_updating_company_feature_account",
  "850": "error_occurred_while_finding_company_feature_account_by_id",
  "851":
    "error_occurred_while_finding_company_feature_account_by_user_feature_id",
  "852": "error_occurred_while_finding_company_feature_account_by_user_id",
  "853":
    "failed_to_fetch_company_feature_account_details_using_user_feature_id",
  "854": "failed_to_create_company_feature_fee",
  "855": "error_occurred_while_fetching_company_feature_fee_records",
  "856": "error_occurred_while_finding_company_feature_fee_by_id",
  "857": "error_occurred_while_finding_company_feature_fee_by_sme_company_id",
  "858": "failed_to_create_company_role_permission",
  "859": "error_occurred_while_fetching_company_role_permissions",
  "860": "error_occurred_while_updating_company_role_permission",
  "861": "error_occurred_while_finding_company_role_permission_by_id",
  "862":
    "error_occurred_while_finding_company_role_permission_by_company_role_id",
  "863": "failed_to_create_company_role",
  "864": "error_occurred_while_fetching_company_roles",
  "865": "error_occurred_while_finding_company_role_by_id",
  "866": "error_occurred_while_updating_company_role",
  "867": "failed_to_create_company_user_feature",
  "868": "error_occurred_while_fetching_company_user_features",
  "869": "error_occurred_while_updating_company_user_feature",
  "870": "error_occurred_while_finding_company_user_feature_by_id",
  "871": "error_occurred_while_finding_company_user_feature_by_sme_company_id",
  "872":
    "error_occurred_while_fetching_features_and_sub_features_for_company_user",
  "873": "failed_to_create_company_user_role",
  "874": "error_occurred_while_fetching_company_user_roles",
  "875": "error_occurred_while_getting_company_user_roles_by_sme_company_id",
  "876": "error_occurred_while_finding_company_user_role_by_id",
  "877": "error_occurred_while_updating_company_user_role",
  "878": "error_occurred_during_sme_onboarding_process",
  "879": "failed_to_fetch_all_sme_companies",
  "880": "error_occurred_while_finding_sme_company_by_id",
  "881": "failed_to_add_company_role_for_sme",
  "882": "error_occurred_while_assigning_permissions_to_sme_company_role",
  "883": "failed_to_add_sme_role",
  "884": "error_occurred_while_assigning_permissions_to_sme_role",
  "885": "failed_to_fetch_all_sme_banks",
  "886": "error_occurred_while_finding_sme_bank_by_id",
  "887": "error_occurred_while_fetching_all_system_banks",
  "888": "error_occurred_while_finding_system_bank_by_id",
  "889": "error_occurred_while_searching_system_banks",
  "890": "error_occurred_while_fetching_all_mas_users",
  "891": "error_occurred_while_fetching_all_mas_customers",
  "892": "error_occurred_while_fetching_mas_users_by_type",
  "893": "mas_user_not_found_in_the_system",
  "894": "error_occurred_while_finding_mas_user_by_id",
  "895": "failed_to_create_mas_admin_user",
  "896": "error_occurred_while_sending_mas_user_invite_for_onboarding",
  "897": "error_occurred_while_verifying_mas_user_onboarding_invite",
  "898": "mas_user_email_or_otp_is_missing",
  "899": "mas_user_otp_not_found_desc",
  "900": "the_request_timed_out_please_try_again_later",
  "910": "a_technical_error_occurred_please_contact_support",
  "911": "failed_to_create_mas_user_role",
  "912": "error_occurred_while_fetching_all_mas_user_roles",
  "913": "error_occurred_while_finding_mas_user_role_by_id",
  "914": "error_occurred_while_updating_mas_user_role",
  "915": "error_occurred_while_fetching_all_mas_roles",
  "916": "error_occurred_while_finding_mas_role_by_id",
  "917": "failed_to_create_mas_role_permission",
  "918": "error_occurred_while_fetching_all_mas_role_permissions",
  "919": "error_occurred_while_finding_mas_role_permission_by_id",
  "920": "error_occurred_while_updating_mas_role_permission",
  "921": "failed_to_fetch_all_mas_fees",
  "922": "error_occurred_while_fetching_all_fees",
  "923": "error_occurred_while_fetching_fee_by_id",
  "924": "failed_to_create_fee",
  "925": "error_occurred_while_updating_fee_by_id",
  "926": "error_occurred_while_deleting_fee_by_id",
  "927": "error_occurred_while_fetching_all_fee_features",
  "928": "error_occurred_while_fetching_fee_feature_by_id",
  "929": "error_occurred_while_deleting_fee_feature",
  "930": "error_occurred_while_updating_fee_feature_by_id",
  "931": "error_occurred_while_creating_fee_feature",
  "932": "no_dashboard_data_found",
  "933": "error_occurred_while_fetching_dashboard_data",
  "934": "error_occurred_while_sending_company_user_onboarding_invite",
  "935": "role_name_is_required",
  "936": "invalid_company_role_id_provided",
  "937": "menu_name_is_required",
  "938": "invalid_menu_id_provided",
  "939": "permission_name_is_required",
  "940": "mas_user_otp_does_not_match",
  "941": "invalid_mas_user_request",
  "942": "error_occurred_during_mas_user_onboarding_approval",
  "943": "failed_to_set_mpin_for_mas_user",
  "944": "mas_user_update_record_not_found",
  "945": "error_occurred_while_updating_mas_user",
  "946": "mas_user_conversion_record_not_found",
  "947": "error_occurred_during_mas_user_conversion",
  "948": "error_occurred_while_fetching_mas_users_by_role_id",
  "949": "error_occurred_while_fetching_company_users_by_role_id",
  "951": "error_occurred_while_fetching_company_users",
  "952": "failed_to_fetch_company_users",
  "953": "pending_transactions_exist_within_authorization_range",
  "954": "money_conversion_process_failed",
  "959": "error_occurred_while_suspending_or_reactivating_company_user",
  "960": "invalid_status_provided_for_the_operation",
  "961": "error_occurred_while_updating_company_information",
  "962": "invalid_company_id_provided",
  "963": "error_occurred_while_searching_mas_fee_records",
  "964": "fee_not_found_for_the_given_criteria",
  "978": "the_selected_onboarding_type_is_not_supported",
  "1001": "purpose_codes_could_not_be_found",
  "1002": "no_beneficiaries_were_found",
  "1003": "the_beneficiary_id_provided_is_invalid",
  "1004": "an_error_occurred_while_fetching_payment_types",
  "1005": "lookup_data_could_not_be_found",
  "1006": "the_requested_authorization_matrix_could_not_be_found",
  "1007": "the_specified_workflow_could_not_be_found",
  "1008": "failed_to_update_workflow",
  "1009": "the_specified_action_type_is_not_supported",
  "1010": "the_provided_payment_indicator_is_invalid",
  "1011": "the_payment_transaction_could_not_be_found",
  "1012": "duplicate_push_detected_to_the_core_banking_system",
  "1013": "error_while_converting_to_dto",
  "1014": "mapping_operation_failed",
  "1015": "a_required_object_is_null",
  "1016": "transfer_type_is_missing",
  "1017": "transfer_type_is_invalid",
  "1018": "beneficiary_account_is_missing",
  "1019": "debit_amount_is_invalid",
  "1020": "currency_code_is_missing",
  "1021": "country_code_is_missing",
  "1022": "payment_date_is_missing",
  "1023": "transaction_status_is_missing",
  "1024": "credit_amount_is_missing",
  "1025": "payment_details_are_missing",
  "1026": "internal_remarks_are_missing",
  "1027": "schedule_time_is_missing",
  "1028": "recurring_id_is_missing",
  "1029": "purpose_code_is_missing",
  "1030": "payment_reference_is_missing",
  "1031": "charge_amount_is_invalid",
  "1032": "charge_bearer_type_is_missing",
  "1033": "beneficiary_email_is_missing",
  "1034": "beneficiary_email_is_invalid",
  "1035": "mobile_number_is_missing",
  "1036": "mobile_number_is_invalid",
  "1037": "transfer_note_is_missing",
  "1038": "recurring_details_are_invalid",
  "1039": "page_number_is_missing",
  "1040": "page_sort_by_is_missing",
  "1041": "product_and_account_are_not_entitled_for_this_operation",
  "1042": "holiday_cutoff_time_has_been_exceeded",
  "1043": "currency_cutoff_time_has_been_exceeded",
  "1044": "error_retrieving_account",
  "1045": "no_accounts_found_desc",
  "1046": "query_execution_failed_desc",
  "1047": "error_retrieving_account_balance",
  "1048": "the_amount_is_invalid",
  "1049": "the_amount_exceeds_the_allowed_limit",
  "1050": "limit_check_failed_desc",
  "1052": "approval_limit_has_been_exceeded",
  "1053": "daily_limit_not_found_desc",
  "1054": "approval_limit_not_found_desc",
  "1055": "no_data_was_found",
  "1056": "procedure_execution_exception_occurred",
  "1057": "an_unknown_error_occurred",
  "1058": "error_while_inserting_authorization_record",
  "1059": "a_generic_error_occurred",
  "1060": "approver_count_not_found_desc",
  "1061": "bank_routing_error_occurred",
  "1062": "no_banks_were_found",
  "1063": "the_fx_quote_request_is_invalid",
  "1064": "failed_to_create_fx_quote",
  "1065": "failed_to_accept_fx_quote",
  "1077": "this_request_to_pay_is_already_initiated",
  "1100": "a_system_error_occurred",
  "1201": "you_are_not_authenticated_or_authorized_to_perform_this_action",
  "1202": "user_profile_or_role_is_missing_please_contact_support",
  "1203": "payment_type_not_found_please_try_again",
  "1204": "authorization_matrix_not_found_please_contact_your_administrator",
  "1205": "beneficiary_not_found_please_check_the_details_and_try_again",
  "1206": "error_occurred_while_fetching_beneficiaries",
  "1207": "invalid_beneficiary_id_provided",
  "1208": "this_beneficiary_has_already_been_removed",
  "1209": "beneficiary_not_found_for_this_user_id",
  "1210": "mapping_failed_for_authorization_history",
  "1211": "error_occurred_while_retrieving_data",
  "1212": "user_permission_is_missing_please_contact_your_administrator",
  "1213": "the_beneficiary_already_has_this_status_assigned",
  "1214": "this_beneficiary_is_currently_inactive",
  "1215": "unknown_status_assigned_to_beneficiary",
  "1216": "the_beneficiary_is_already_in_rejected_status",
  "1217": "unsupported_country_code_for_ifsc_or_swift_code",
  "1218": "the_object_provided_is_null_please_check_your_input",
  "1219": "beneficiary_name_cannot_be_null",
  "1220": "beneficiary_email_cannot_be_null",
  "1221": "ifsc_or_swift_code_cannot_be_null",
  "1222": "beneficiary_nickname_cannot_be_null",
  "1223": "beneficiary_bank_name_cannot_be_null",
  "1224": "beneficiary_bank_clearing_code_cannot_be_null",
  "1225": "page_number_cannot_be_null",
  "1226": "page_size_cannot_be_null",
  "1227": "page_sort_by_cannot_be_null",
  "1228": "beneficiary_id_cannot_be_null",
  "1229": "the_field_contains_invalid_special_characters",
  "1230": "the_beneficiary_email_address_is_invalid",
  "1231": "this_beneficiary_already_exists",
  "1232": "iban_number_cannot_be_empty",
  "1233": "iban_number_is_too_short_please_provide_a_valid_iban",
  "1234": "mismatch_between_sme_company_id_and_provided_company_id",
  "1235": "assembler_failed_while_processing_the_request",
  "1236": "this_feature_is_not_allowed_for_your_account",
  "1237": "remarks_are_missing_please_add_a_remark",
  "1238": "beneficiary_account_cannot_be_null",
  "1239": "this_beneficiary_is_already_waiting_for_approval",
  "1240": "edit_not_allowed_due_to_pending_transactions",
  "1241": "the_operation_was_successful",
  "1242": "the_database_query_failed_please_try_again",
  "1243": "a_rejection_remark_is_mandatory_for_beneficiaries",
  "1244": "status_code_cannot_be_null",
  "1245": "favorites_cannot_be_assigned_to_this_beneficiary",
  "1246": "invalid_request_sub_feature_id_is_required",
  "1247": "failed_to_update_beneficiary_details",
  "1248": "sme_user_is_not_authenticated_or_authorized_to_proceed",
  "1249": "the_beneficiary_was_updated_successfully",
  "1250": "the_beneficiary_was_partially_updated_successfully",
  "1251": "the_beneficiary_update_operation_failed",
  "1252": "the_beneficiary_selected_is_invalid",
  "1253": "the_beneficiary_selected_is_invalid",
  "1254": "update_failed",
  "1255": "invalid_beneficiary",
  "1256": "it_s_not_approved_beneficiary",
  "1257": "beneficiary_nick_name_is_invalid",
  "1258": "beneficiary_nick_name_already_exists",
  "1259": "user_not_allowed_to_approve",
  "1260": "user_role_is_not_assigned",
  "1261": "not_gx_user",
  "1262": "consent_usage_subtype_is_empty",
  "1263": "entered_amount_is_higher_than_balance",
  "1264": "invalid_amount_or_balance",
  "1265": "invalid_amount_precision",
  "1266": "create_fxquote_error",
  "1267": "nonce_creation_failed",
  "1268": "nonce_id_is_null",
  "1269": "invalid_nonce",
  "1271": "beneficiary_approver_name_missing",
  "1272": "beneficiary_metro_map_creation_failed",
  "1401":
    "we_were_unable_to_retrieve_the_balances_for_your_dashboard_please_try_again_later",
  "1402": "the_system_failed_to_fetch_your_total_account_balance_at_this_time",
  "1403":
    "the_total_assets_balance_could_not_be_retrieved_please_refresh_and_try_again",
  "1404": "no_account_details_were_found_for_the_given_account_id",
  "1405": "no_currency_information_is_available_for_your_request",
  "1406": "we_could_not_fetch_your_liabilities_balance_please_try_again_later",
  "1407": "the_provided_account_id_is_invalid_please_check_and_try_again",
  "1408": "no_account_statements_are_available_for_the_selected_criteria",
  "1409": "the_custom_statement_request_could_not_be_saved_please_retry",
  "1410": "there_are_no_immediate_attention_transactions_available",
  "1411": "no_recent_transactions_were_found_for_this_account",
  "1412": "we_could_not_map_the_transaction_history_data_please_retry_later",
  "1413": "no_activities_were_found_for_this_account",
  "1414": "the_requested_lookup_type_was_not_found",
  "1415": "we_could_not_convert_the_entity_data_into_dto_format",
  "1416": "no_lookup_data_is_available_for_your_request",
  "1417": "the_user_id_you_provided_is_invalid",
  "1418": "the_request_data_is_missing_or_invalid",
  "1419": "the_account_id_provided_is_invalid",
  "1420": "the_account_number_you_entered_is_invalid",
  "1421": "no_activities_were_found_for_your_deposit_account",
  "1422": "no_activities_were_found_for_your_loan_account",
  "1423": "you_are_not_authenticated_or_authorized_to_access_this_resource",
  "1424": "the_provided_iban_number_is_invalid",
  "1425": "no_account_products_were_found_for_this_user",
  "1426": "the_account_statement_could_not_be_downloaded",
  "1427": "no_cards_were_found_for_this_account",
  "1428": "the_provided_transaction_id_is_invalid",
  "1429": "the_account_number_entered_is_too_short",
  "1430": "a_valid_date_is_required_and_cannot_be_empty",
  "1431": "the_start_date_provided_is_invalid",
  "1432": "delivery_type_must_be_specified",
  "1433": "delivery_type_must_be_either_mail_or_whatsapp",
  "1434": "delivery_type_must_be_either_courier_or_collection_center",
  "1435": "only_one_chequebook_request_is_allowed_at_a_time",
  "1436": "the_number_of_chequebook_leaves_is_invalid",
  "1437": "the_courier_collector_s_name_is_required",
  "1438": "the_courier_country_code_is_missing",
  "1439": "the_courier_collector_s_phone_number_is_required",
  "1440": "the_courier_collector_s_address_is_required",
  "1441": "the_courier_collector_s_state_is_required",
  "1442": "the_courier_collector_s_city_is_required",
  "1443": "the_courier_collector_s_zip_code_is_required",
  "1444": "the_bank_branch_id_provided_is_invalid",
  "1445": "the_bank_branch_name_is_required",
  "1446": "the_bank_branch_address_is_required",
  "1447": "bank_branch_coordinates_are_required",
  "1448": "the_collection_center_country_code_is_required",
  "1449": "the_collection_center_phone_number_is_required",
  "1450": "delivery_type_selection_is_required",
  "1451": "a_self_physical_copy_must_be_provided",
  "1452": "a_self_email_address_is_required",
  "1453": "auditor_fields_must_remain_empty_for_self_delivery_type",
  "1454": "an_auditor_physical_copy_is_required",
  "1455": "both_physical_copies_are_required_for_this_request",
  "1456": "a_self_email_address_is_required_when_both_copies_are_requested",
  "1457": "the_delivery_type_you_selected_is_not_supported",
  "1458": "the_auditor_s_name_is_required",
  "1459": "the_auditor_s_email_is_required",
  "1460": "the_auditor_s_physical_copy_request_has_missing_fields",
  "1461": "auditor_fields_must_be_empty_if_no_physical_copy_is_requested",
  "1462": "chequebook_type_must_be_standard",
  "1463": "the_auditor_s_country_code_is_required",
  "1464": "the_auditor_s_phone_number_is_required",
  "1465": "the_auditor_s_address_is_required",
  "1466": "the_auditor_s_state_is_required",
  "1467": "the_auditor_s_city_is_required",
  "1468": "the_auditor_s_zip_code_is_required",
  "1469": "total_account_balance_could_not_be_found",
  "1470": "currency_information_for_total_balance_could_not_be_found",
  "1471": "total_assets_balance_could_not_be_found",
  "1472": "currency_information_for_total_assets_could_not_be_found",
  "1473": "total_liabilities_balance_could_not_be_found",
  "1474": "currency_information_for_liabilities_could_not_be_found",
  "1475": "currency_conversion_data_could_not_be_retrieved",
  "1476": "response_from_the_central_bank_could_not_be_found",
  "1477": "the_account_status_returned_is_unknown",
  "1478": "no_pending_requests_were_found",
  "1479": "progress_status_could_not_be_updated",
  "1480": "completed_status_could_not_be_updated",
  "1481": "reset_pending_status_could_not_be_updated",
  "1482": "no_bank_list_data_was_found",
  "1483": "no_favourite_accounts_were_found",
  "1484": "no_favourite_deposits_were_found",
  "1485": "no_favourite_loan_accounts_were_found",
  "1486": "no_favourite_cards_were_found",
  "1487": "no_email_templates_were_found",
  "1488": "an_unknown_error_occurred_please_try_again_later",
  "1491": "no_portal_transactions_are_available",
  "1498": "no_card_activity_are_available",
  "1600": "the_provided_payer_id_is_invalid",
  "1601": "the_requested_payer_could_not_be_found",
  "1602": "the_payer_is_not_authenticated_or_authorized_to_perform_this_action",
  "1603": "an_error_occurred_while_processing_the_payer_information",
  "1604": "unable_to_retrieve_payer_details_due_to_a_query_failure",
  "1605": "payer_details_are_missing_or_null",
  "1606": "the_payer_name_is_required_to_continue",
  "1607": "the_payer_email_address_is_required",
  "1608": "address_line_1_is_required_for_the_payer",
  "1609": "the_payer_bank_name_must_be_provided",
  "1610": "please_add_remarks_before_proceeding",
  "1611": "this_payer_has_already_been_removed",
  "1612": "the_payer_status_is_unknown_or_unsupported",
  "1613": "the_provided_sme_id_is_invalid",
  "1614": "you_are_not_allowed_to_use_this_feature",
  "1615": "this_payer_is_already_waiting_for_approval",
  "1616": "the_payer_status_has_already_been_rejected",
  "1617": "this_status_is_already_applied_to_the_payer",
  "1618": "authorization_data_for_the_payer_was_not_found",
  "1619": "you_have_already_approved_this_payer",
  "1620": "the_approval_status_provided_is_invalid",
  "1621": "the_payer_details_were_updated_successfully",
  "1622": "failed_to_update_the_payer_details",
  "1623": "some_payer_details_could_not_be_updated",
  "1624": "an_invoice_already_exists_for_this_payer",
  "1625": "a_purchase_order_already_exists_for_this_payer",
  "1626": "the_provided_email_address_is_invalid",
  "1627": "the_payer_has_not_been_approved_yet",
  "1628": "the_payer_mobile_number_is_required",
  "1629": "the_payer_country_code_is_required",
  "1630": "the_payer_mobile_code_is_required",
  "1631": "this_email_address_is_already_associated_with_another_payer",
  "1632": "this_mobile_number_is_already_associated_with_another_payer",
  "1634": "emirates_id_verification_failed_please_try_again",
  "1635": "no_image_has_been_uploaded",
  "1636": "the_id_card_image_has_not_been_uploaded",
  "1637": "the_selfie_image_has_not_been_uploaded",
  "1638": "a_technical_error_occurred_please_try_again_later",
  "1639": "the_request_timed_out_please_try_again",
  "1640": "a_remote_service_error_occurred_please_try_again_later",
  "1700": "the_request_to_pay_request_is_invalid",
  "1701": "an_internal_server_error_occurred",
  "1702": "the_status_update_is_invalid",
  "1703": "failed_to_save_the_request_to_pay_data",
  "1704": "invalid_request_to_pay_request_filter",
  "1705": "the_payer_information_is_invalid",
  "1706": "the_deposit_account_is_invalid",
  "1707": "the_amount_specified_is_invalid",
  "1708": "the_selected_collection_date_is_invalid",
  "1709": "the_expiry_date_is_invalid",
  "1710": "the_sme_user_is_not_authenticated",
  "1711": "payer_contact_information_is_invalid",
  "1712": "invalid_mobile_number_provided",
  "1713": "invalid_email_address_provided",
  "1714": "invalid_payer_name_desc",
  "1715": "the_request_is_invalid",
  "1716": "invalid_page_number_desc",
  "1717": "invalid_page_size_desc",
  "1718": "invalid_search_text_desc",
  "1719": "the_payer_list_is_empty",
  "1720": "no_request_to_pay_records_available",
  "1722": "no_records_found_for_the_specified_user_id",
  "1723": "no_accounts_found_desc",
  "1724": "failed_to_fetch_request_to_pay_records",
  "1725": "payer_contact_is_required_for_ad_hoc_requests",
  "1726": "payer_name_is_required_for_ad_hoc_requests",
  "1727": "record_not_found_desc",
  "1728": "query_execution_failed_desc",
  "1729": "no_data_found_for_the_specified_user_id",
  "1730": "invalid_webhook_token_desc",
  "1731": "missing_webhook_token",
  "1732": "invalid_request_to_pay_status_code",
  "1733": "invalid_request_to_pay_details",
  "1812":
    "the_login_process_id_is_missing_please_restart_the_login_process_and_try_again",
  "1820":
    "your_account_has_been_registered_on_another_device_please_log_out_from_the_other_device_and_try_again",
  "1898": "the_enter_email_is_not_same_as_login_email",
  "2003": "file_format_is_required_please_upload_a_supported_file_format",
  "2004": "the_selected_debit_account_is_invalid_please_verify_and_try_again",
  "2005": "value_date_is_required_please_select_a_valid_date",
  "2006": "the_requested_job_could_not_be_found",
  "2007": "the_uploaded_file_is_empty_please_upload_a_file_with_data",
  "2008": "the_file_name_is_invalid_please_rename_the_file_and_try_again",
  "2009": "the_uploaded_file_type_is_not_supported",
  "2010": "file_path_configuration_is_missing_please_contact_support",
  "2011": "an_error_occurred_while_processing_the_file_please_try_again",
  "2012": "the_specified_account_could_not_be_found",
  "2013": "the_provided_job_process_id_is_invalid",
  "2014": "reject_notes_are_required_to_complete_this_action",
  "2015": "the_selected_reject_status_is_invalid",
  "2016": "the_provided_job_name_is_invalid",
  "2017": "the_bulk_type_status_is_invalid_for_this_operation",
  "2018": "the_provided_unique_key_is_invalid",
  "2019": "this_record_has_already_been_processed",
  "2020": "this_record_has_already_been_rejected",
  "2021": "the_specified_lookup_type_is_invalid",
  "2022": "the_requested_action_is_invalid",
  "2023": "the_reject_action_is_not_allowed_for_the_current_status",
  "2024": "authorization_type_is_required",
  "2025": "approval_status_is_required",
  "2026": "remarks_are_required_to_complete_this_action",
  "2027": "bulk_type_information_is_missing",
  "2028": "the_selected_job_id_does_not_belong_to_the_selected_bulk_type",
  "2029": "please_upload_a_file_to_continue",
  "2030": "this_action_is_only_allowed_when_the_file_is_ready_for_review",
  "2031": "reject_notes_exceed_the_maximum_allowed_length",
  "2032": "value_date_cannot_be_a_past_date",
  "2033": "an_error_occurred_while_executing_the_request_please_try_again",
  "2034": "a_file_with_the_same_name_already_exists",
  "2035": "bulk_type_is_required",
  "2036": "the_file_already_exists_please_upload_a_file_with_a_different_name",
  "2037": "the_configured_file_path_does_not_exist",
  "2038": "failed_to_move_the_file_to_the_target_location",
  "2039": "file_path_is_not_available_during_processing",
  "2040": "you_are_not_allowed_to_update_your_own_record",
  "2041": "payment_type_or_currency_information_is_missing",
  "2042": "the_provided_status_is_invalid",
  "2043": "unable_to_read_the_uploaded_file",
  "2044": "the_uploaded_file_contains_invalid_data",
  "2045":
    "formulas_are_not_allowed_in_the_uploaded_file_please_remove_them_and_try_again",
  "2131": "no_direct_debit_records_were_found_for_the_specified_criteria",
  "2132": "no_direct_debit_records_were_found_for_the_selected_status",
  "2133":
    "the_required_date_information_was_not_provided_or_could_not_be_found",
  "2205": "this_consent_is_paused_so_can_t_able_tpo_revoke",
  "2206":
    "ths_action_can_t_able_to_work_for_this_single_instant_payment_consent",
  "2207":
    "ths_action_can_t_able_to_work_for_this_single_future_dated_payment_consent",
  "2208": "the_enter_account_number_is_already_exist",
  "5003":
    "we_encountered_an_issue_while_processing_data_in_the_system_cache_please_try_again_after_some_time",
  AccountsNotFound: "there_are_no_accounts_to_display_at_the_moment",
  AuthMatrixNotFound: "the_transaction_type_you_are_looking_for_is_unavailable",
  BanksNotFound: "the_requested_bank_does_not_exist_or_is_no_longer_available",
  CountryListEmpty: "for_this_user_country_list_is_not_available",
  IncorrectMPin: "mpin_you_have_entered_is_incorrect_please_enter_correct_mpin",
  InviteUserNotFound:
    "the_user_you_re_trying_to_invite_could_not_be_found_please_check_the_details_and_try_again",
  "MPIN Previously Used":
    "mpin_you_have_entered_is_previously_used_please_use_different_mpin",
  ManageThirdPartyNotFound:
    "there_are_no_third_party_records_available_to_manage_at_this_time",
  ManageUserNotFound: "there_are_no_users_available_to_manage_at_the_moment",
  NoPendingApprovals: "no_pending_approval_left",
  Nofileselected: "no_file_selected",
  UserAccessReqNotFound:
    "the_requested_user_access_record_does_not_exist_or_may_have_been_removed",
  bioMetricAuthToManyTimes: "to_many_attempts_fingerprint_sensor_disable",
  consentFailed: "we_couldn_t_complete_your_consent_request_please_try_again",
  consentUpdateFailed:
    "we_couldn_t_complete_your_consent_update_request_please_try_again",
  healthCheckError: "a_technical_error_occurred_due_to_a_health_check_failure",
  largeFileSelectError: "file_too_large_max_allowed_size_is_5_mb",
  noAccountsFound: "no_account_information_is_available_at_the_moment",
  noAdminUsers: "no_admin_users_are_available_at_the_moment",
  noApprovalFound:
    "we_couldn_t_find_any_approval_to_display_please_try_again_later",
  noBankFound: "we_couldn_t_find_any_bank_to_display_please_try_again_later",
  noBeneficiaryFound:
    "we_couldn_t_find_any_beneficiary_to_display_please_try_again_later",
  noCardsFound: "no_card_information_is_available_at_the_moment",
  noCbsScheduleTransactions:
    "no_cbs_scheduled_transactions_are_available_at_the_moment",
  noCbsScheduleTransfer:
    "no_cbs_scheduled_transfers_are_available_at_the_moment",
  noConsentDetails: "consent_details_cannot_be_displayed_at_the_moment",
  noConsentServiceDetails:
    "consent_service_details_cannot_be_displayed_at_the_moment",
  noConsentServiceUpdates:
    "no_updates_are_available_for_this_consent_service_at_the_moment",
  noConsentUpdates: "no_updates_are_available_for_this_consent_at_the_moment",
  noCurrentConsentServices:
    "there_are_currently_no_active_consent_services_available_to_display",
  noCurrentConsents:
    "there_are_currently_no_active_consents_available_to_display",
  noDepositsFound: "no_deposit_information_is_available_at_the_moment",
  noHistoryConsentServices:
    "there_is_no_consent_service_history_available_at_the_moment",
  noHistoryConsents: "there_is_no_past_consent_history_available_at_the_moment",
  noInstantPayBeneficiaryFound:
    "we_couldn_t_find_any_instant_pay_beneficiary_to_display_please_try_again_later",
  noLoansFound: "no_loan_information_is_available_at_the_moment",
  noPaymentHistory: "no_payment_history_is_available_at_the_moment",
  noPaymentTypeFound:
    "we_couldn_t_find_any_payment_type_to_display_please_try_again_later",
  noPortalScheduleTransfer:
    "no_portal_scheduled_transfers_are_available_at_the_moment",
  noQuickTransferFound:
    "we_couldn_t_find_any_quick_transfer_to_display_please_try_again_later",
  noRecentTransactionFound:
    "we_couldn_t_find_any_recent_transaction_to_display_please_try_again_later",
  noRepairTransactionFound:
    "we_couldn_t_find_any_repair_transaction_to_display_please_try_again_later",
  noRtpFound: "no_rtp_records_are_available_at_the_moment",
  noScheduleTransactionFound:
    "we_couldn_t_find_any_schedule_transaction_to_display_please_try_again_later",
  noScheduleTransferFound:
    "we_couldn_t_find_any_schedule_transfer_to_display_please_try_again_later",
  noTransactionFound:
    "we_couldn_t_find_any_transaction_to_display_please_try_again_later",
  nopayerFound: "no_payer_was_found_at_the_moment",
  pendingApprovalLeftBeneficiary: "no_pending_approval_left_in_beneficiary",
  pendingApprovalLeftBulkPayment: "no_pending_approval_left_in_bulk_payment",
  pendingApprovalLeftPayer: "no_pending_approval_left_in_payer",
  pendingApprovalLeftPayroll: "no_pending_approval_left_in_payroll",
  pendingApprovalLeftTransaction: "no_pending_approval_left_in_transaction",
  pleaseSelectFile: "please_select_file",
  redirectionTimeOut:
    "the_redirection_to_the_central_bank_or_payment_gateway_has_timed_out",
  selectedFileExceed: "all_selected_files_exceed_5_mb",
};
